export function waitForQrCodeRender(container: HTMLElement | null, timeoutMs = 3000): Promise<void> {
  return new Promise(resolve => {
    if (!container) {
      resolve();
      return;
    }
    const start = Date.now();
    const check = () => {
      const qrHosts = Array.from(container.querySelectorAll('qrcode'));
      const allRendered = qrHosts.every(host => host.querySelector('canvas, img, svg'));
      if (allRendered || Date.now() - start >= timeoutMs) {
        resolve();
      } else {
        requestAnimationFrame(check);
      }
    };
    check();
  });
}
